export default __webpack_public_path__ + "static/media/loading.c5c2d73f.svg";